"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A326))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRSearch = createSVGIcon(
  <path
    d="M16.301 16.293A8.375 8.375 0 1 0 4.45 4.457 8.375 8.375 0 0 0 16.3 16.293Zm0 0L22.008 22"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRSearch",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "BonYS7",
      defaultMessage: "Search",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
